import PWAInstall from '@khmyznikov/pwa-install/react-legacy';
import React, { useEffect, useRef } from 'react';

import { PWAInstallElement } from '@khmyznikov/pwa-install';
import { Box, Typography } from '@mui/material';

import isAppleDevice from '@common/helpers/isAppleDevice';
import { useToggle } from '@common/helpers/useToggle';

import VideoPlayerModal from '../VideoPlayerModal';
import NonIosInstallBanner from './NonIosInstallBanner';

function PwaInstallBanner() {
	const installRef = useRef<PWAInstallElement>(null);
	const isApple = isAppleDevice();
	const controls = useToggle();
	const hideInstallGuide =
		typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('isTis');

	const openVideo = () => {
		controls.onOpen({
			videoUrl: 'https://storage.campus.key.study/videos/9415256784+ios+v1.mp4',
			title: 'Installation guide',
		});
	};

	function setAppleDialogBottom(extraPx: number) {
		const host = installRef.current as any;
		const root = host?.shadowRoot as ShadowRoot | null;
		if (!root) return false;

		const dialog = root.querySelector(
			'#pwa-install-element .install-dialog.apple.available',
		) as HTMLElement | null;

		if (!dialog) return false;

		const bottom = 20 + extraPx;
		dialog.style.bottom = `${bottom}px`;
		dialog.style.maxHeight = `calc(-${bottom}px + 85vh)`;
		return true;
	}

	useEffect(() => {
		if (!isApple) return;

		let cancelled = false;

		const loop = () => {
			if (cancelled) return;
			const ok = setAppleDialogBottom(80);
			if (!ok) requestAnimationFrame(loop);
		};

		loop();
		return () => {
			cancelled = true;
		};
	}, [isApple]);

	const handleInstallAvailable = () => {
		const el = installRef.current as any;
		if (!el) return;
		el.showDialog?.(true);
		el.install?.();

		requestAnimationFrame(() => setAppleDialogBottom(80));
	};

	if (!isApple) return <NonIosInstallBanner />;

	return (
		<>
			<PWAInstall
				styles={{ '--text-color-description': '#fff' }}
				disableClose
				ref={installRef}
				disableScreenshots
				disableDescription
				name="Campus PWA"
				icon="/icons/icon-192x192.png"
				manifestUrl="/manifest.webmanifest"
				useLocalStorage={false}
				onPwaInstallAvailableEvent={handleInstallAvailable}
			/>
			{!hideInstallGuide && (
				<Box
					sx={{
						position: 'fixed',
						bottom: '30px',
						display: 'flex',
						justifyContent: 'center',
						width: '100%',
						padding: '0 16px',
					}}
				>
					<Typography variant="subtitle1">
						<Box onClick={openVideo} component="span" sx={{ cursor: 'pointer', color: '#2d6cdf' }}>
							Watch&nbsp;
						</Box>
						installation guide
					</Typography>
				</Box>
			)}
			{controls.isOpen && <VideoPlayerModal controls={controls} />}
		</>
	);
}
export default PwaInstallBanner;
